module.exports = __webpack_public_path__ + "static/media/bnb-logo.7f666faf.png";